import React, { useState, useEffect } from 'react';
import Tree from 'rc-tree';
import useStickyState from '../../../../../functions/useStickyState';

const CampaignsTree = ({ 
    clientCampaigns, 
    onSelect, 
    onNewCampaignClick,
    selectedCampaignId,
    expandedKeys: externalExpandedKeys,
    onExpand: externalOnExpand
}) => {
    const [internalExpandedKeys, setInternalExpandedKeys] = useStickyState([], 'campaigns_expanded');

    // Use external props if provided, otherwise use internal state
    const expandedKeys = externalExpandedKeys !== undefined ? externalExpandedKeys : internalExpandedKeys;
    const setExpandedKeys = externalOnExpand || setInternalExpandedKeys;

    const onExpand = (expandedKeys, { node, expanded }) => {
        setExpandedKeys(expandedKeys);
    };

    const handleExpandAll = (expand = true) => {
        if (clientCampaigns) {
            if (expand) {
                const allClientIds = Object.keys(clientCampaigns);
                setExpandedKeys(allClientIds);
            } else {
                setExpandedKeys([]);
            }
        }
    };

    // Check if all client folders are currently expanded
    const allClientIds = clientCampaigns ? Object.keys(clientCampaigns) : [];
    const isAllExpanded = allClientIds.length > 0 && allClientIds.every(id => expandedKeys.includes(id));

    // Return null until clientCampaigns is ready
    if (!clientCampaigns || Object.keys(clientCampaigns).length === 0) {
        return null;
    }

    const getTreeData = () => {
        if (!clientCampaigns) {
            return [];
        }
        
        let r = Object.entries(clientCampaigns)
            .sort(([clientIdA], [clientIdB]) => clientIdA.localeCompare(clientIdB))
            .map(([clientId, clientArray]) => {
                return {
                    title: `${clientId}`,
                    isLeaf: false,
                    key: clientId,
                    children: clientArray[0].campaigns
                        ?.sort((a, b) => a.campaign_id.localeCompare(b.campaign_id))
                        ?.map(campaign => ({
                            title: campaign.campaign_name,
                            key: campaign.campaign_id,
                            client_id: clientId,
                            isLeaf: true,
                            defaultExpandAll: true, 
                        }))
                };
            });
        return r;
    };

    const treeData = getTreeData();

    return (
        <>
            <div style={{ marginBottom: '8px' }}>
                <button 
                    className='btn btn-sm btn-outline-secondary' 
                    onClick={() => handleExpandAll(!isAllExpanded)}
                    style={{ fontSize: '12px', padding: '4px 8px' }}
                >
                    {isAllExpanded ? 'Collapse All' : 'Expand All'}
                </button>
            </div>
            <Tree
                treeData={treeData}
                onSelect={onSelect}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                selectedKeys={selectedCampaignId ? [selectedCampaignId] : []}
            />
            <div className='row'>
                <div className='col-2'>
                    <hr />
                    <button className='btn btn-primary new_campaign' onClick={onNewCampaignClick}>
                        New Campaign
                    </button>
                </div>
            </div>
        </>
    );
};

export default CampaignsTree; 